/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import {
    Section,
    getState,
    getConfig,
    getBrand,
    format,
    publish,
    COUPON_FREQUENCY_LABELS,
    COUPON_DAY_COUNT_LABELS,
    icons,
    iconLabel,
    showModal,
    getOwaTcdaoContext,
} from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, sectionListCss } from './style'
import CouponType from './coupon-type'

const state = getState('bond_detail.coupon_features', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const {issue, offer, ask, bid} = useBondDetail()

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-coupon-features'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Coupon features"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <dl css={sectionListCss}>
                <dt>Coupon</dt>
                <dd>{format.cpn3(issue.coupon)}</dd>

                <dt>Coupon frequency</dt>
                <dd>{COUPON_FREQUENCY_LABELS[issue.frequencyCode] || format.empty()}</dd>

                <dt>Coupon type</dt>
                <dd><CouponType issue={issue} offer={offer}/></dd>

                <dt>Next coupon</dt>
                <dd>{format.mdy(issue.nextCoupon)}</dd>

                <dt>First coupon</dt>
                <dd>{format.mdy(issue.firstCoupon)}</dd>

                <dt>Last coupon</dt>
                <dd>{format.mdy(issue.lastCoupon)}</dd>

                <dt>Day count</dt>
                <dd>{COUPON_DAY_COUNT_LABELS[issue.currDaycount] || format.empty()}</dd>
            </dl>

            <div className="vertical-offset-sm">
                <button
                data-name="bond-detail-coupon-features-coupon-payment-calculator"
                className="link-button"
                onClick={() => {

                    if (getConfig('entitlements.ETradeCalculator', 'No') === 'Yes') {
                        showModal({
                            view: 'calculator',
                            cusip: issue.cusip,
                            action: 'B',
                            price: ask && ask.price || 100,
                            showCoupon: true,
                        })
                        return
                    }

                    let base = getConfig('bw_service_host') + '/' + getBrand()
                    let sp = new URLSearchParams()
                    sp.set('p_javascript', 2)
                    sp.set('p_data_source', ask && ask.id || bid && bid.id ? 'I' : 'D')
                    sp.set('p_id', ask && ask.id || bid && bid.id || issue.cusip)
                    sp.set('p_price_type', 1)
                    sp.set('p_price', ask && ask.price || bid && bid.price || 100)
                    sp.set('p_quantity', ask && ask.quantity || bid && bid.quantity || 0)
                    sp.set('p_commission', '')
                    sp.set('p_ts', Date.now())

                    let owaTcDaoContext = getOwaTcdaoContext()
                    let url = `${base}/${owaTcDaoContext}/pkg_calc_bond_online.seed?${sp.toString()}`

                    publish('open', {
                        url,
                        name: '_blank',
                        options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
                    })
                }}
                >
                { iconLabel(icons.calculate, 'Calculate coupon payment') }
                </button>
            </div>
            </Section>
        </div></div>

        <div className="xs-show row vertical-offset-sm"></div>
    </div>

    </React.Fragment>
}
